import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { checkoutUrl } from '../data/checkout';
import { product } from '../data/product';
import { bonuses } from '../data/bonuses';
const total = [product, ...bonuses].reduce((sum, item) => sum + item.value, 0);
export function StickyMobileCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const update = () => {
      const offer = document.getElementById('offre');
      const pastHero = window.scrollY > 700;
      let offerInView = false;
      if (offer) {
        const r = offer.getBoundingClientRect();
        offerInView = r.top < window.innerHeight && r.bottom > 0;
      }
      setVisible(pastHero && !offerInView);
    };
    update();
    window.addEventListener('scroll', update, {
      passive: true
    });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);
  return <AnimatePresence data-id="element-189" data-mp="29hpatdsphmp3">
      {visible && <motion.div initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-ink-line bg-[#070d1a] px-4 pb-[calc(0.75rem+env(safe-area-inset-bottom))] pt-3 md:hidden" data-id="element-190" data-mp="24jdzeymrj44r">
          <div className="flex items-center gap-3" data-id="element-191" data-mp="1qtaj0oake4n8">
            <div className="shrink-0 leading-tight" data-id="element-192" data-mp="1lsw7gw9r8ckg">
              <p className="text-[11px] text-cream-muted line-through" data-id="element-193" data-mp="1lrbehb3391op">{total} $</p>
              <p className="font-display text-2xl text-cream" data-id="element-194" data-mp="1gub9z4lw06zp">27 $</p>
            </div>
            <a href={checkoutUrl} className="flex-1 whitespace-nowrap rounded-full bg-gold px-4 py-3.5 text-center text-[15px] font-bold text-ink transition-[background-color,transform] duration-150 ease-out active:scale-[0.98]" data-id="element-195" data-mp="1cszsjmd62s2l">
              Je commande maintenant
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}